export default {
  bookingPage: {
    title: 'PURCHASE',
    subtitle: '遊ぶ日を予約する',
    weekday: '平日',
    holiday: '休日',
    duration: {
      '0': '体験時間:',
      '1': '体験時間:',
      '2': '体験時間:',
      '3': '体験時間:',
      '4': '体験時間:',
      '5': '体験時間:',
      '6': '体験時間（ゲーム準備を含む）:'
    },
    variableTimeWarning: '※所要時間は個人差があります',
    ageWarning: '対象年齢:',
    cancellationWarning: `※予約完了後も日時変更は可能です。
      ただし、お客様都合による参加料の払い戻しは承っておりません。`
  }
};
